var _path, _circle, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefundIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 0.468911C6.39645 0.161722 7.60355 0.161722 8.75 0.468911V0.468911C9.89645 0.776101 10.9418 1.37965 11.7811 2.21891V2.21891C12.6203 3.05817 13.2239 4.10355 13.5311 5.25V5.25C13.8383 6.39645 13.8383 7.60355 13.5311 8.75V8.75C13.2239 9.89645 12.6203 10.9418 11.7811 11.7811V11.7811C10.9418 12.6203 9.89645 13.2239 8.75 13.5311V13.5311C7.60355 13.8383 6.39645 13.8383 5.25 13.5311V13.5311C4.10355 13.2239 3.05817 12.6203 2.21891 11.7811V11.7811C1.37965 10.9418 0.7761 9.89645 0.468911 8.75V8.75C0.161722 7.60355 0.161722 6.39645 0.468911 5.25V5.25C0.776101 4.10355 1.37965 3.05817 2.21891 2.21891V2.21891C3.05817 1.37965 4.10355 0.7761 5.25 0.468911V0.468911Z",
    fill: "url(#paint0_linear_589_55324)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.99989,
    cy: 6.99891,
    r: 5.09559,
    fill: "url(#paint1_linear_589_55324)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31526 3.61397C5.03532 3.62156 6.15226 3.03192 6.69743 2.62183C6.86897 2.49278 7.11343 2.48579 7.28683 2.61233C7.86523 3.03442 8.98998 3.64101 10.5424 3.62511C10.7445 3.62304 10.9262 3.75865 10.9541 3.95885C11.2757 6.2619 10.716 10.3257 7.11121 11.5864C7.03251 11.614 6.94309 11.614 6.86406 11.5874C2.32291 10.0592 2.86813 4.80898 3.07809 3.78428C3.10173 3.66892 3.1975 3.61345 3.31526 3.61397Z",
    fill: "url(#paint2_linear_589_55324)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11133 6.68038L6.5906 8.21491L8.88876 5.91686",
    stroke: "#F69247",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_589_55324",
    x1: 7,
    y1: 0,
    x2: 7,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E88744"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_589_55324",
    x1: 6.99989,
    y1: 1.90332,
    x2: 6.99989,
    y2: 12.0945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F27F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCB578"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_589_55324",
    x1: 7.13108,
    y1: 5.32288,
    x2: 7.13108,
    y2: 11.4938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundIcon);
export default __webpack_public_path__ + "static/media/refund_icon.74c501a07eff8ec2d506c756a3caedf6.svg";
export { ForwardRef as ReactComponent };